import { Component, OnInit, ViewChild, HostListener, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { AppConfig } from '../app.config';

import { User } from '../model/user/user';
import { UserActionIdentifiers } from '../model/user/user-properties/user-actionIdentifier';
import { CosyCommunicationControllerService } from '../service/controller/cosy-communication-controller.service';
import { DomSanitizer } from '@angular/platform-browser';
import { UXControllerService } from '../service/controller/ux-controller.service';
import { AutofillMonitor } from '@angular/cdk/text-field';

declare var grecaptcha: any;
@Component({
  selector: 'app-cosy-login',
  templateUrl: './cosy-login.component.html',
  styleUrls: ['./cosy-login.component.css']
})
@HostListener('window:resize', ['$event'])
export class CosyLoginComponent implements OnInit {

  @ViewChild('staticTabs')
  staticTabs: TabsetComponent;

  @ViewChild('cosyLogin') cosyLogin: ElementRef;
  @ViewChild('cosyPassword') cosyPassword: ElementRef;
  private cssUrl: string = "/assets/default/css/app.css";
  private appName: string;
  public errorMessage: string = '';
  private parameters;
  public showErrorMessage: boolean = false;
  public isLoginAutofilled: boolean = false;
  public isPasswordAutofilled: boolean = false;
  private userLoginObject: User;
  public responseToken: any = null;
  @Input()
  public singleLogin: boolean = true;
  @Output()
  private cosyToken = new EventEmitter<string>();;

  public userCredentialForm: FormGroup;
  public loginUserActionID = this.config.getConfig('loginUserActionID');

  constructor(
    private activatedRoute: ActivatedRoute,
    private cosyCommunicationControllerService: CosyCommunicationControllerService,
    private uxControllerService: UXControllerService,
    private formBuilder: FormBuilder,
    private router: Router,
    private title: Title,
    private config: AppConfig,
    public sanitizer: DomSanitizer,
    private _autofill: AutofillMonitor
  ) {
  
  }

  ngOnInit() {

    if( this.uxControllerService.currentBreadCrumbTitle == 'Home'){
      this.userLogin(this.uxControllerService.loginUserModel, true);
    }
    if( this.uxControllerService.currentBreadCrumbTitle == 'LogOut'){
      this.userLogOut();
    }
    let appID;
    let managedAppID;
    let autoAuthorize;
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      appID = params['appID'];
      managedAppID = params['managedAppID'];
      this.appName = params['appName'];
      if (this.appName != null) {
        //Set Title
        this.title.setTitle(this.appName + ' Login');
        //AppCSS-Datei
        this.cssUrl = "/assets/apps/" + this.appName.replace(/Standard/gi, '').replace(/ /g, '').toLocaleLowerCase() + "/css/app.css";
        let link: HTMLLinkElement = document.createElement("link");
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('content-type', 'text/css');
        link.setAttribute('id', 'app');
        link.setAttribute('href', this.cssUrl);
        link.onerror = function (evt) {
          link.setAttribute('href', '/assets/default/css/app.css');
          document.head.appendChild(link);
        };
        document.head.appendChild(link);
      }
      else this.title.setTitle('Login');
    });
    

    if (this.singleLogin) autoAuthorize = true;
    else autoAuthorize = false;
    
    this.userCredentialForm = this.formBuilder.group({
      login: ['', [Validators.required]],
      password: [''],
      appID: [appID],
      managedAppID: [managedAppID],
      autoAuthorize: [autoAuthorize]
    });
  }

  ngAfterViewInit() {
    this._autofill.monitor(this.cosyLogin)
    .subscribe(e => {
        if (e.isAutofilled) {
          this.isLoginAutofilled = true;
        }
      }
    );
    this._autofill.monitor(this.cosyPassword)
    .subscribe(e => {
        if (e.isAutofilled) {
          this.isPasswordAutofilled = true;
        }
      }
    );
  }

  onCredentialChange(value){
    this.isLoginAutofilled = false;
    this.isPasswordAutofilled = false;
  }
  
  
  authorizeUser(appID: string, managedAppID: string) {
    this.userLoginObject.autoAuthorize = true;
    this.userLoginObject.appID = appID;
    this.userLoginObject.managedAppID = managedAppID;
    this.userLogin(this.userLoginObject, true)
  }

  userLogin(userModel: User, isValid: boolean) {

   
    this.uxControllerService.loginUserModel = new User();
    this.uxControllerService.loginUserModel.login = userModel.login;
    this.uxControllerService.loginUserModel.password = userModel.password;
    this.uxControllerService.loginUserModel.autoAuthorize = false;
    this.uxControllerService.loginUserModel.appID = null;
    this.uxControllerService.loginUserModel.managedAppID = null;
   

    this.showErrorMessage = false;
    this.errorMessage = '';
    this.userLoginObject = userModel;
    UserActionIdentifiers.LoginUserActionID = this.loginUserActionID;
    this.cosyCommunicationControllerService.authorizeUser(UserActionIdentifiers.LoginUserActionID, userModel).subscribe(
      responseToken => {
        this.responseToken = responseToken;
      },
      error => {
        if (error.name == 'HttpErrorResponse') {
          console.error('Server nicht erreichbar, bitte versuchen Sie es später noch einmal: ' + error);
          this.showErrorMessage = true;
          this.errorMessage = 'Server nicht erreichbar, bitte versuchen Sie es später noch einmal oder wenden Sie sich an ihren Admin.';
        }
        else console.error('Error in recieving Response Token : ', error)
      },
      () => {
        if (this.responseToken.errorCode == 0) {
          this.cosyCommunicationControllerService.globalSessionID = this.responseToken.cosyToken;
          this.parameters = { sessionID: this.responseToken.cosyToken };
          this.uxControllerService.setRuntimeKeys(this.responseToken.cosyToken);
          this.router.navigate(['/myapp'], { queryParams: this.parameters });
/*        Problem: bis die Antwort kommt ist die Auswertung des Ergebnisses(Anzeige Button RuntimeKey/CosyBackend/DynaEdits) schon erfolgt
          this.cosyCommunicationControllerService.getRuntimeKey(this.responseToken.cosyToken, "ActivePrimaryGroupID").subscribe(
            key => this.uxControllerService.ActivePrimaryGroup = key["value"]
          );     
*/      } else if (this.responseToken.errorCode == 1) {
          this.cosyToken.emit(this.responseToken.cosyToken);
          this.userLoginObject.cosyToken = this.responseToken.cosyToken;
          this.uxControllerService.cosyToken = this.responseToken.cosyToken;
          this.cosyCommunicationControllerService.getRuntimeKey(this.responseToken.cosyToken, "ActivePrimaryGroupID").subscribe(
            key => this.uxControllerService.ActivePrimaryGroup = key["value"]
          );
        }
        else {
          let responseMsg = this.cosyCommunicationControllerService.responsePerErrorToken(this.responseToken.errorCode);
          if (responseMsg != null) {
            this.showErrorMessage = responseMsg.showErrorMsg;
            this.errorMessage = responseMsg.errorMsg;
          }
        }
      }
    );
  }

  userLogOut() {
    this.responseToken = null;
    this.cosyToken.emit(null);
  }

}
